import HttpService from "./htttp.service";

class UserService {
  // Fetch user details
  async fetchUserDetails(emails = "") {
    try {
      // Build query parameters dynamically
      let endpoint = "/user/details";

      if (emails) {
        // If emails are provided, append them as a query param
        endpoint += `?emails=${encodeURIComponent(emails)}`;
      }

      const response = await HttpService.get(endpoint);
      return response;
    } catch (error) {
      console.error("Error fetching user details:", error);
      throw error;
    }
  }

  // Update user details (e.g., name, profile picture, settings)
  async updateUserDetails(userData) {
    try {
      const payload = {
        data: {
          type: "users",
          attributes: userData,
        },
      };
      const response = await HttpService.patch(`/user/details`, payload);
      return response.data;
    } catch (error) {
      console.error("Error updating user details:", error);
      throw error;
    }
  }

  // Delete a user account
  async deleteUserAccount() {
    try {
      const response = await HttpService.delete(`/user/delete`);
      return response.data;
    } catch (error) {
      console.error("Error deleting user account:", error);
      throw error;
    }
  }

  /**
   * Fetch all workspaces the authenticated user is a member of.
   */
  async fetchUserWorkspaces() {
    try {
      const response = await HttpService.get("/user/user-workspace");
      return response;
    } catch (error) {
      console.error("Error fetching user workspaces:", error);
      throw error;
    }
  }

  /**
   * Switch the active workspace for the authenticated user.
   * @param {string} workspaceId 
   */
  async switchActiveWorkspace(workspaceId) {
    try {
      const payload = { workspaceId };
      const response = await HttpService.post("/user/user-workspace/switch", payload);
      return response.data;
    } catch (error) {
      console.error("Error switching workspace:", error);
      throw error;
    }
  }

  /**
   * Check the user's workspace context status (has workspace, has profiles).
   */
  async checkWorkspaceStatus() {
    try {
      const response = await HttpService.get("/user/workspace-status");
      return response;
    } catch (error) {
      console.error("Error checking workspace status:", error);
      throw error;
    }
  }

}

export default new UserService();
